module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("A "), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("TEAM")])])])]), _vm._v(" had flown over to Naples to bring Andreo up to speed on his latest acquisition, Venstar.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tensions were running high for there was not a single Venstar executive present who did not feel that his job might be on the line. The ruthlessness that distinguished Andreo D’Alessio’s brilliance in the business world was a living legend.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘This should help you to fit faces to the senior staff when you come over to visit us,’ one of the directors said with a rather nervous laugh as he passed over a company newsletter adorned with a photograph of key personnel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Andreo D’Alessio studied the front page with keen dark eyes. Only one woman featured in the line-up and he only noticed her in the first instance because she messed up the picture. She was very tall and her stooped and self-effacing stance shrieked all the awkwardness of a very skinny baby giraffe striving in vain to hide its overly long limbs. Heavy framed spectacles dwarfed her thin, earnest face. But what had caught Andreo’s attention was her pronounced untidiness. Stray riotous curls stuck out from her head hinting that her hair was in dire need of a good brushing. His frown deepening, he went on to note that her ill-fitting suit jacket was missing a button and the hem on one leg of her shapeless trousers was sagging. He almost shuddered. The epitome of cool elegance himself, he was less than tolerant of those who offended his high standards.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Who is the woman?’ he enquired.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("‘Woman?’")])]), _vm._v(" Andreo was asked blankly and he had to point her out in the photograph before his companions made the necessary leap in understanding.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Oh, you mean…"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Pippa!")])]), _vm._v("’ a Venstar executive finally exclaimed as though challenged to recognise the reality that the senior staff actually harboured a female in their ranks. ‘Pippa’s our assistant finance manager—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You don’t tend to think of her as being a woman…has a brain like a calculator. An academic high-flyer who thinks of nothing but work,’ a director proclaimed with appreciation. ‘She’s absolutely dedicated. She hasn’t taken a single holiday in three years—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘That’s unhealthy,’ Andreo cut in with disapproval. ‘Stressed and exhausted employees operate below par and make mistakes. The lady needs a vacation and HR should have a word with her about smartening up her slovenly appearance.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jaws dropped. Paunches were sucked in and jackets smoothed down for none of the men was quite sure which imperfections might put one at risk of attracting the clearly very dangerous label of being ‘slovenly’. An uncomfortable silence fell. Slovenly? "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Was")])]), _vm._v(" Pippa slovenly? Nobody had ever really looked at Pippa long enough to have noticed one way or the other. That she was an economics prodigy and very efficient was all anybody had ever cared about.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still scanning the picture to note the level of personal care as displayed by the male contingent of the line-up, Andreo found yet more scope for censure. ‘I don’t believe in the concept of dressing down because it doesn’t impress clients. I don’t want to see jeans in the office. A smart appearance implies discipline and it "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("does")])]), _vm._v(" impress. This man here could do with a haircut and a new shirt.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He pointed out the offender in an impatient tone. ‘Attention to self-presentation is never wasted.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Almost every man in the room decided to go on a diet, get a haircut and buy a new suit. Andreo, all six feet five inches of him, after all, could be seen to practise what he preached. Lean, mean and undeniably magnificent in a to-die-for Armani designer suit, Andreo was an impressive enough sight to inspire the younger men with an eager desire to emulate him. Ricky Brownlow, however, who was far too vain of his blond good looks to believe himself in need of either a diet or a haircut, concealed a self-satisfied smile. He had just worked out how he could promote his current lover over Pippa’s head without attracting undue criticism.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘The HR department also needs to set new targets. I want to see a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("very")])]), _vm._v(" rapid improvement in Venstar’s abysmal record of promoting women to executive level,’ Andreo concluded.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("When her immediate superior, Ricky Brownlow, invited her into his office and broke the bad news, Pippa was betrayed into a startled exclamation. ‘Cheryl…is going to be the new finance manager?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Ricky nodded in casual confirmation as if there were nothing strange about that development.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cheryl Long? The giggly brunette who currently acted as her junior was now to become her "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("boss?")])]), _vm._v(" That bombshell sent Pippa into severe shock. After all, she herself had been Acting Finance Manager for almost three months and she had had high hopes of the position being made permanent. Until that moment she had had no idea that Cheryl had even applied for the job.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I thought that I should let you know before HR informed you through official channels,’ Ricky added in the tone of a man who had gone out of his way to do her a favour.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But Cheryl has hardly any qualifications and only a couple of months of experience in the section…’ Pippa was quite unable to conceal her astonishment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘New blood keeps the company fresh and sharp.’ Ricky Brownlow frowned at her in reproof and a painful flush lit her fair skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A slender young woman with shaken blue eyes and vibrant auburn curls scraped back from her brow and held tight by a clip, Pippa walked back to her desk. She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("could")])]), _vm._v(" have taken losing out to a superior candidate, she told herself urgently. But was she just being a bad loser? Shame at the fear that she might be that petty consumed Pippa, who suffered from a conscience more over-developed than most. Self-evidently, she decided, Cheryl Long had talents that she herself had failed to recognise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The animated buzz of dialogue around Pippa reminded her of the party being held that evening to welcome Andreo D’Alessio and she suppressed an exasperated sigh. She had never liked parties and she liked work social occasions even less. However, now that she had been turned down for the job that she had naively assumed was in the bag, she had better make an appearance at the celebrations lest other people start thinking that she begrudged Cheryl her good fortune.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cheryl was about to become her boss. Pippa swallowed the thickness building in her tight throat. For goodness’ sake, had she screwed up somewhere so badly that she had blown her own promotion prospects right out of the water? If that was the case, why hadn’t she been told and at least warned of her mistake? Cheryl was going to be her boss. Cheryl, whom Pippa had had to be rather stiff with on several recent occasions for her incredibly long lunch breaks and shoddy work? Cheryl, who seemed to spend half the day chatting and the rest of it flirting with the nearest available male? Cheryl, who was mercifully on leave that day…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa sank deeper and deeper into shock. Hothoused as she had been from preschool level right through to university, and always expected to deliver exceptional results, failure of any kind threw her into an agony of self-blame and self-examination. Somehow, somewhere, she was convinced, she had fallen seriously short of what was expected of her…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I wish he was more into publicity and we had a better photograph of him,’ one of the project assistants, Jonelle, sighed in a die away voice that set Pippa’s teeth on edge. ‘But we’ll see if he lives up to his extraordinary reputation when we see him in the flesh tonight—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her companion giggled. ‘He’s supposed to have bought his last girlfriend a set of diamond-studded handcuffs…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa had no need to ask who was under discussion for Andreo D’Alessio’s exploits as an international playboy, business whizkid and womaniser were very well documented for a male who went to great lengths not to be photographed. Her soft full mouth curled in helpless disgust. The man that offered "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("her")])]), _vm._v(" diamond-studded handcuffs as a gift would find himself skydiving without a parachute. But then no man was ever likely to offer her diamond-studded sex toys of any description, and very grateful she was too not to be the type to attract that kind of perverted treatment! Just listening to another female agonise in fascination over a male set on reducing her sex to the level of toys for fun moments made her feel ill.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I bet he’s an absolute babe.’ Jonelle had a dreamy look on her pretty face. ‘Hot stuff—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I bet he’s small and rather round in profile just like his late father,’ Pippa inserted with deliberate irony. ‘And the reason that Andreo D’Alessio doesn’t like publicity is that he loves the rumour that he’s much bigger and better looking than he really is.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Maybe the poor guy is just sick of being chased for his mega-millions,’ Jonelle opined in reproach.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And maybe he wouldn’t be chased at all if he didn’t have them,’ Pippa mocked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mid-morning she was called to an HR interview. Informed for the second time that her application to become Finance Manager had been unsuccessful, she felt grateful but still a little surprised that Ricky Brownlow had been kind enough to forewarn her of the disappointment coming her way. When she asked if there had been any complaints about her work performance, the older man was quick to reassure her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And that’s very much to your credit when one considers events in recent months,’ the HR director continued in a sympathetic tone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Picking up on that oblique reference to her father’s death in the spring, Pippa paled. ‘I’ve been lucky to have my work to keep me busy.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Are you aware that you haven’t utilised your holiday entitlement in several years?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her fine brows pleated and she shrugged. ‘Yes…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ve been asked to ensure that you take at least three weeks off effective from the end of this month—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Three weeks…"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("off?")])]), _vm._v("’ Pippa gasped in dismay.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ve also been authorised to offer you the opportunity of a sabbatical for six or twelve months.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘A…a sabbatical…are you serious?’ Pippa exclaimed in an even greater state of disconcertion.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Impervious to Pippa’s discouraging response, the older man went on to wax lyrical about the benefits of taking a work break. He pointed out that Pippa had not taken a gap year between school and university and had in fact commenced employment at Venstar within days of her graduation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You spend very long hours in the office.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("like")])]), _vm._v(" working long hours—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Nevertheless I’m sure that you will enjoy de-stressing during your holiday in two weeks’ time and that you’ll consider the opportunity of extending your break with a sabbatical. Think of how refreshed you would be on your return to work.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("De-stressing?")])]), _vm._v(" Ultra sensitive, Pippa picked up on that word and wondered if that was why she had been passed over in the promotion stakes. Did she come across as stressed to her colleagues? Irritable? Or was it that she seemed lacking in management skills? There had to be a reason why she had been unsuccessful—there "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" to be! Whatever, she was not being given a choice about whether or not she took a holiday and that bothered her. Why now and not before? Was there concern that she might not adapt well to the new command structure in the finance section?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Deeply troubled by her complete loss of faith in her own abilities, Pippa worked through her lunch hour and when, around three that afternoon, she glanced up and saw the empty desks around her, she frowned in surprise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Where is everybody?’ she asked Ricky Brownlow when she saw him in his office doorway.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Left early to get ready for the party. You should be heading home too.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa hated to leave a task unfinished but then she recalled the events of the day and the holiday that had been pressed on her. That had been a hurtful lesson in the reality that she was not indispensable. Rising from her desk, she lifted her bag. She had reached the ground floor before she appreciated that the rain was bouncing off the pavements outside and, in her haste to depart, she had left her coat behind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Too impatient to wait on the lift again, she took the stairs. The finance floor was silent and she was walking towards the closet where her coat hung when she heard Ricky Brownlow’s voice carrying out from his office.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘When I was in Naples, Andreo D’Alessio made it very clear that he likes sexy, fanciable women around him,’ Ricky was saying in a pained, defensive tone. ‘He took one horrified look at the piccy of our Pippa Plain in the company newsletter and it was clear that she would never fit the executive bill in his eyes, so I backed Cheryl’s application instead. Cheryl’s less qualified, I grant you, but she’s also considerably more presentable—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa had frozen in her tracks. Pippa…"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Pippa Plain")])]), _vm._v("?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Pippa Stevenson is an excellent employee,’ a voice that she recognised as belonging to one of the older directors countered coldly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘She’s an asset as a backroom girl but her best friend couldn’t call her a looker "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("or")])]), _vm._v(" a mover or shaker. She has all the personality of a wet blanket,’ Ricky Brownlow pronounced with a viciousness that flayed Pippa to the bone. ‘To be frank, I didn’t think we’d be doing ourselves any favours if we ignored D’Alessio’s sexist preferences and served up Pippa Plain to him on his first day here!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shattered by what she had overheard but even more terrified of being found eavesdropping, Pippa crept back out to the corridor and fled without her coat. In that one devastating dialogue, she had learned why Cheryl instead of herself was to be Venstar’s next finance manager. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Pippa Plain?")])]), _vm._v(" Her tummy rolled with nausea but she refused to let herself cringe. Ricky Brownlow had laid it on the line: unlike Pippa, Cheryl was extremely attractive and popular with men. The curvaceous brunette’s looks rather than her ability had influenced her selection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A cold, sick knot of humiliation in her stomach, Pippa swallowed hard and blinked back stinging tears. It was so unfair. That job had had her name on it and she had worked darned hard for promotion. Nobody had the right to judge another person on their appearance. It was utterly wrong and against all employment legislation and Venstar deserved to be sued for treating her so shabbily. She imagined standing up at a tribunal and being forced to relate Ricky’s demeaning comments and compressed her lips with a shudder of recoil. No, there was no way that she would take the company to a tribunal and make herself an object of sniggering pity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Her best friend couldn’t call her a looker…Pippa Plain?")])]), _vm._v(" Was that a fact? Doubtless Ricky would never credit that when she was fifteen years old a modelling agency had offered her a lucrative contract. Of course, her father had been outraged by the mere suggestion that his daughter would engage in what he deemed to be a lowbrow career. But for the eight years that had followed Pippa had secretly cherished the memory of her one stolen day of rebellion against Martin Stevenson’s strict dictates. She had gone to the agency in secret and let them make her up and do her hair. She had watched in fascination as cosmetic magic and clever clothing had transformed her from a pale, skinny beanpole into a glowing, leggy beauty. Then the old lech of a photographer had made a pass at her and sent her fleeing for home again, convinced that everything her father had said about the dangerous corruption of the modelling industry was true.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Why shouldn’t she try to effect even some small part of that transformation on her own behalf? She could attend the party looking her best just to confound Ricky Brownlow and that sexist louse, Andreo D’Alessio. How could a man be so stupid that he put beauty ahead of brains even in a business capacity?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Standing in the rain getting absolutely soaked through, Pippa dug out her mobile phone and rang her friend Hilary. Hilary Ross was a hairdresser and when asked if she could squeeze Pippa in for a last-minute hair-rescue mission, she was so taken aback by the request that she gasped, ‘Are you being frivolous at last? Is it Christmas or something?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Or something,’ Pippa confirmed a little unevenly. ‘I’m going out tonight and it’s really important.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hilary had a heart the size of a world globe and told her to come straight over, while adding that Pippa should have known better than to think that she had to phone and ask one of her oldest friends for an appointment. ‘Especially when you only make the effort to get your hair done about once a year!’ she teased in conclusion.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa caught an underground train that would take her to Hilary’s salon in the west London suburb of Hounslow. As she was jostled by other passengers while she stood in the aisle because there were no seats available Pippa’s teeming thoughts were troubled. Sad though it was to acknowledge, she was relieved that her father was not alive to be shamed and disappointed by her failure to win promotion. But then when had she ever managed to meet her parent’s expectations and make him proud of her? she asked herself with pained and guilty regret.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her mind travelled back almost six years to the summer that her family life had been destroyed. She had been just seventeen when her parents and three other families had gone on their final holiday together to the Dordogne region of France. Her friendship with Hilary Ross stretched back as far as their childhoods. The Ross family had been part of the group that had gone to France and as the holiday had been an annual event there had been no reason to suspect that that year would be any different from any previous year. But that particular summer everything that could have gone wrong "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" gone wrong. In fact it had been a disastrous vacation for all concerned but nobody had had the nerve to admit that and it had still lasted almost the full six weeks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No sooner had they arrived in France than her then best friend, Tabby, had got involved in a passionate secret fling with a French guy staying nearby and had become so besotted that she had scarcely noticed that Pippa had been alive for the remainder of their stay. During that same period, however, Pippa had had her heart broken and her self-esteem smashed without anybody even noticing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But the conclusive life-altering event of that fatal holiday had been the dreadful car accident that had left Pippa’s mother dead and put her father into a wheelchair. Tabby’s father, Gerry Burnside, had got drunk and crashed a car full of passengers, shattering the lives of all his friends. Pippa had been much closer to her mother than she had ever been to her harsh and demanding father and she had been devastated by her mother’s sudden death. Before the crash her father had been a science teacher and an active sportsman and he had never managed to come to terms with his disability.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Furthermore, as a young man Martin Stevenson had wanted to be a doctor but had narrowly missed out on the exam grades required. From the hour of Pippa’s birth, her father had been determined that his daughter should live out his dream of becoming a doctor for him and she had been pressed into doing her academic best from a very early age. But the consequences of that appalling car accident, which had also claimed the lives of Tabby’s father, Hilary’s parents and both Jen’s and Pippa’s mothers had traumatised Pippa and she had had to tell her father that she could not face a career in medicine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cruel intensity of her father’s disappointment had been almost more than Pippa’s conscience could bear and his bitterness had been terrible to live with. For nearly six years afterwards, Pippa had nonetheless been her parent’s main carer. But, no matter how hard she had worked to please him with high grades in the economics degree she’d pursued and with tender care of his needs at home, he had never forgiven her for turning her back on the chance to become a doctor. Pippa remained wretchedly aware of what she saw as her own shortcomings. She was totally convinced that the really gutsy woman whom she wanted to be would have been fired by an unquenchable desire to study medicine after that car accident rather than put off for life and convinced that she was too soft to last the course.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she made herself remember just how much she had once adored France, she could hardly credit that she had not visited the country of her own mother’s birth since that tragic summer. She had even made excuses to avoid attending Tabby’s wedding. Thankfully, however, Tabby’s husband, Christien, brought his wife over to London on regular visits, so Pippa had been able to maintain contact with her friend. But wasn’t it really past time that she came to terms with her mother’s death and visited Tabby and Christien at Duvernay, the Laroche family’s beautiful château in Brittany? How often had her friend invited her? Her conscience twanged. Shouldn’t she spend at least part of the holiday she had to take with Tabby in France?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Oh, no, this is the day you close at lunchtime and I completely forgot!’ Pippa groaned in dismay when Hilary, having met her at the door of her tiny apartment took her across the passage into the hairdressing salon, which was strikingly silent and empty. ‘For goodness’ sake, why didn’t you remind me that it was your half-day?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hilary was small and slim with enormous grey eyes and spiky blonde hair that had the very slightest hint of blue to match her T-shirt. Only a year Pippa’s junior, she actually looked barely eighteen and she grinned. ‘Are you kidding? Do I look that patient? You’re finally going out on a date and I can’t wait to find out who the bloke is!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa stiffened. ‘There’s no bloke. It’s the big party for the new MD tonight—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But you were all out of breath on the phone and I thought you were excited—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Not excited…upset,’ Pippa conceded jerkily. ‘I bombed out at work, I fell "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("flat")])]), _vm._v(" on my face—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What on earth—?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I didn’t get the job,’ Pippa muttered in a wobbly undertone and then the whole unhappy story came tumbling out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hilary listened and tried not to wince while she dug into a cupboard in the tiny staff room and poured Pippa a stiff drink from the brandy someone had given her at Christmas.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I don’t touch it, you know I don’t…’ Pippa attempted to push the glass away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You’re as white as a sheet. You need a boost.’ Hilary pressed her down into a seat by the washbasins and deemed a change of subject the best policy. ‘So you want to knock ’em dead in the aisles at Venstar tonight—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Some chance!’ Wrinkling her nose at the taste, Pippa drank deep and the unfamiliar alcohol ran like fire down into her cold, empty tummy. Like the warmth of her friend’s sympathy, however, it was a soothing sensation and she was incredibly grateful that she had ignored her father’s withering sarcasm and had attended her first school reunion just a few months earlier. After Tabby had made a permanent move to France, Pippa had been delighted to meet up with Hilary again at the reunion and learn that the blonde also lived in London. After that tragic car accident, their paths had been forced apart and Tabby and Pippa had lost touch with Hilary and with the fourth member of that teenage friendship, Jen Tarbert.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Even blindfolded, you could knock ’em dead,’ Hilary repeated with determination, trying not to think unkind thoughts about Pippa’s deceased father. However, it was an unfortunate truth that even when Pippa had been a child her parent had been a domineering bully with a wounding tongue and he had done a real hatchet job on his daughter’s self-esteem.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("While Hilary washed her hair, Pippa remembered to ask after her friend’s kid sister, Emma. ‘How’s she doing?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hilary chattered on happily about the teenage sister she adored before saying, ‘Will you let me do your make-up too?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘If you don’t mind…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Why would I mind? I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("love")])]), _vm._v(" doing faces!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, you can only do your best—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘With a bone structure as good as yours, I would hope so.’ Hilary watched Pippa stiffen and sighed before she pressed another brimming glass of brandy into the redhead’s hand, told her that she was far too tense and hustled her upstairs to her cluttered apartment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ll have to rush home to get changed,’ Pippa remarked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You haven’t got the time. You’ll be late enough as it is.’ Hilary hurried into her sister’s bedroom and plundered the packed wardrobe there to emerge with a strappy dress in a glorious shade of turquoise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I can’t borrow anything that belongs to your sister!’ Pippa protested.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Emma decided that this made her look too old and you know how picky teenagers are…there’s no way she’ll ever wear it now.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I wouldn’t feel comfortable in a style like that,’ Pippa muttered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Lighten up, Pippa,’ Hilary urged in a pained tone. ‘You’re young and you can wear just about anything with your figure. It’s not a revealing dress, so what are you worried about?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In Pippa’s opinion any garment that bared her shoulders, her thin arms and the sheer pitiful tininess of her breasts "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" much too revealing. Yet, her friend was being so kind and supportive that she was reluctant to reject her generosity. Both women wore the same size in shoes but, yet again, there was a great gap between their personal preferences. Hilary adored shoes with high heels whereas Pippa rarely wore heels because she already stood five feet eleven inches in her bare feet. A pair of three-inch high gold beaded sandals were set beside the dress and then Hilary showed her guest into the bathroom to enable her to take a shower before her transformation commenced.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Almost two hours later, and only after Pippa had donned the contact lenses she carried in her bag but rarely utilised, Hilary whisked the towel off the mirror and marched Pippa in front of it. ‘You look totally, incredibly gorgeous and if you argue about that I swear I’m going to have a fight with you!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In shocked silence, Pippa stared at her colourful reflection. ‘I don’t look like me—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No offence intended, but that’s only because “me” neglects her hair, never wears make-up and can’t be bothered dressing up!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa’s eyes stung a little but she could hardly blink for the amount of mascara on her lashes. She swallowed hard and said gruffly, ‘Thanks. I don’t look like a loser and you wouldn’t believe how much that means to me.’")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Andreo D’Alessio was bored. He was also in a very bad mood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had not asked for a party. He had not wanted a party. He disliked surprises and he did not think that surprise parties had a role to play in the business world. He was not entertained by long speeches either. He had even less time for flattery and employees in a high state of excitement, particularly when it was obvious that a healthy proportion had overindulged in alcohol before attending the event. Having left the conference hall with the excuse of an important call, he was crossing the hotel foyer when he saw the ravishing redhead. Then he saw her, so stunning that she stopped him in his tracks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hair the rich colour of heavy cinnamon silk tumbled to her shoulders in a smooth, shining fall that reflected the light and framed an oval face of perfect symmetry. Her eyes were the clear, bright blue of the midsummer sky, her full mouth painted coral-pink to highlight the invitation of her soft lips. Her height alone would have attracted his attention for she was unusually tall for a woman. Nearly six feet in height, Andreo calculated with appreciation, and still confident enough to wear high heels. Of all things he abhorred the absurdity of trying to match his own very tall, well-built frame to that of some tiny, birdlike creature half his size. The redhead with her taut white shoulders, slender feminine curves and wondrously endless and shapely legs would "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("fit")])]), _vm._v(" him to perfection…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That fast, voracious male hormones kicking into lusty overdrive at the enervating prospect of the precise intimate fit of the gorgeous woman he was watching, Andreo decided that he was surveying his next lover.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa gazed into the crowded conference hall, which was buzzing with Venstar employees, and wondered if anyone would even recognise her. With the curls she loathed straightened by Hilary’s expertise with a blow-dryer, her spectacles discarded and in borrowed finery, she looked different. The amount of male attention she had attracted since her arrival at the vast hotel had made her very aware of that fact.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unfortunately, the girlie dress made her feel horribly exposed and self-conscious. She wasn’t used to men staring at her and all her life she had been shy. Got up in a no-nonsense trouser suit with work-related issues providing the framework for every dialogue with male colleagues, she had managed fine. But, shorn of that sensible façade, it was a challenge to appear impervious to the lustful appraisals she was receiving. Her chin tilting, she was on the brink of entering the hall when sudden silence fell within. Seeing the man moving towards the podium on the platform, she decided to stay where she was until he had finished making his speech.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As the speaker took up position Pippa stared and then laughed out loud. Oh, dear, Jonelle and every other woman fantasising about the physical attractions of the billionaire Andreo D’Alessio were suffering a very big let-down indeed to their wild fantasies.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Care to share the joke?’ a male voice urged lazily by her side.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa stiffened in surprise for she had not noticed that there was a man standing that close and she felt far too awkward to turn her head to look at him direct. ‘I was just thinking that a lot of people must have been very disappointed with Andreo D’Alessio,’ she said a little breathlessly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Disconcerted, Andreo frowned. ‘And why would you think that?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Something in that accented drawl sent a tiny little shiver of warning down her spine and might have silenced her had not Pippa been in the mood to be sharp, rather than soothing. ‘I suppose that I should’ve said that the women will be disappointed. He’s not even a little bit fanciable,’ Pippa remarked with some satisfaction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No?’ At that point, Andreo believed that she was only pretending not to know who he was. After all, the Venstar shindig had kicked off over an hour earlier and he had been the centre of attention from the outset. He assumed she was making a move on him and, having been subjected to some strange pick-up routines in his time, he was curious to see where she planned to travel after such an opening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, he’s downright short. In fact, he’s so small, he would look more at home sitting under a mushroom dressed all in green like a leprechaun,’ Pippa pronounced.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Belatedly, Andreo realised that she was studying Salvatore Rissone, whom he planned to put in charge of Venstar after the business had been restructured. ‘Height is not everything.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘He looks like he’s rather too fond of his food as well,’ Pippa added with a cruelty that was quite unlike her. ‘And he’s definitely going bald. No wonder he doesn’t like publicity photos. He’s not exactly Mr Universe, is he?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Movie-star looks are not required in business.’ Andreo was angered by her unkind comments about Sal’s homely appearance. ‘He is a fine man—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, he’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("not,")])]), _vm._v("’ Pippa cut in with growing heat. ‘Andreo D’Alessio is a very rich man and the only reason people talk him up is because they’re either hugely impressed by his money or…’ As she spun round, giving way to her hurt resentment of Andreo D’Alessio to address her companion direct, she looked at him for the first time and what she was about to say went clean out of her mind again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was rare for Pippa to be forced to look up at a man. But what sent her brain into free fall was the sheer dazzling effect of this particular male animal up close. From the bronzed skin enhancing the lean, hard, elegant planes of his proud cheekbones to the stubborn masculine angularity of his jawbone, he was strikingly handsome. His mouth was wide and firm, his brows level and dark to match the gleaming luxuriance of his cropped black hair. But it was the piercing quality of eyes dark as ebony and accentuated by a frame of lush inky lashes that entrapped her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("‘Or…?’")])]), _vm._v(" Andreo collided with her turquoise gaze and found his annoyance mysteriously evaporating beneath the onslaught of those spectacular eyes. She was staring up at him in the most uncool way, her response to his sexual magnetism patent in her dilated pupils, and amused satisfaction gripped him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She really "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("didn’t")])]), _vm._v(" know who he was. She really had mistaken Sal Rissone for him. She was not teasing him or trying to capture his interest with a novel approach. Perhaps he was at risk of turning into one of those painful guys who took himself much too seriously, Andreo reflected abruptly. He decided that he ought to be challenged rather than antagonised by the unusual experience of hearing himself criticised. It certainly made a change from the fawning flattery that had been his lot throughout the evening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Or…?’ Pippa was magnetised by his proximity and inexplicably feeling very short of breath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You were saying that people talk up Andreo D’Alessio because he is wealthy and "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("because")])]), _vm._v("…?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘His reputation scares them half to death,’ Pippa filled in jerkily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What have you got against Andreo?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You’re an Italian, aren’t you?’ Somewhat belatedly, Pippa connected his delicious growling accent to his likely nationality. Delicious? The dark timbre of his deep, low-pitched drawl was impossibly sexy. Thrown by the strange emergence of thoughts that seemed to have no direct input from her brain, she shifted off one foot onto the other. Without the smallest warning, she felt her nipples snap tight into stiff little buttons inside her bodice and her cheeks burned hot while she wondered what on earth was happening to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I am.’ Andreo continued to study her. No matter how hard or how long he studied her, her colouring was a source of continual fascination to him: that glowing cinnamon hair and those turquoise eyes enhanced by skin that had initially been pale as milk but that was now flaring a soft rose pink. It had been a long time since he had seen a woman blush and he was intrigued. ‘You work for Venstar?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa nodded but she was extremely tense. ‘You referred to Andreo D’Alessio as if you know him personally…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was Italian, Pippa was thinking in dismay. He had to work for D’Alessio and, if he was part of the initial wave of imported employees, he was unlikely to be a junior member of the team. Her tongue darted out in a nervous flicker over the soft underside of her lower lip.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Andreo found himself imagining that moist pink tip tracing an erotic path of exploration over his bared skin. The sudden throb of his aroused sex startled him for he was long past the teenage years when self-control in the radius of a beautiful woman had often been a challenge. ‘Perhaps I’m just curious to know what you have against a man you’ve never met,’ he breathed almost harshly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pippa tossed her head, cinnamon tresses spilling back against her slim white shoulders. Cautious as she was trying to be, it was already too late because the alcohol in her bloodstream was firing her every response with an unfamiliar aggression. ‘How do you know I’ve never met him?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Andreo elevated a fine black brow. ‘You…"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("have")])]), _vm._v("?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, I haven’t, but I don’t need to meet him in the flesh to know that he’s a sexist dinosaur, who discriminates against women to make himself feel more powerful!’ Pippa slung bitterly.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbe681c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italianbosssmistressthe_ch01.vue
// module id = 63
// module chunks = 0